/*!
 * jQuery flexField plugin
 * version: 0.01 (2012-10-26)
 *
 * Written by David Perry for the Pythian Group
 *
 * Call on a <select> element to cause that element to be treated as a
 * dynamic flex field input.  This plugin automatically creates a hidden
 * input with the same name as the <select>, so you don't need to take care
 * of that yourself.
 *
 * Usage:
 *      <select name="my_name"></select>
 *      <script>
 *      $('select[name=my_name]').flexField( init_obj );
 *      </script>
 * Parameters in init_obj:
 * - data: a FLAT array of objects which represent flex field items.
 *              The objects must have id, parent_id and description keys.
 *              (They may have others which are used by your code.)
 *
 * - value: a FLAT array of IDs which describes the full path
 *              through the tree to the desired initial value.  Optional.
 *
 * - callback: a javascript function which will be passed the object
 *              which was selected.  Will always be passed a leaf node object.
 *              Optional.
 *
 *
 * Implementation note: this plugin was based around the first pattern
 * given at this URL:
 * http://coding.smashingmagazine.com/2011/10/11/essential-jquery-plugin-patterns/
 *
 */
;(function($, window, document, undefined) {

var pluginName = 'flexField';

/*
 * Constructor.  Store info we'll need to handle this selector widget
 */
function flexField( element, init_obj ) {
    this.element = element;
    // Add empty object to data to create the empty option
    this.add_empty_object( init_obj );
    this.field_data = init_obj.data;
    this._name = pluginName;
    this.set_callback( init_obj.callback );
    this.select_obj = $(element).clone();
    this.select_obj.removeAttr('id');

    // Store the initial desired path in a member list.
    // Shift values off the front if/as we need to rebuild the widget.
    // If it's empty then the list should be built with the first member
    // in each level selected by default.
    this.force_values = ( $.isArray(init_obj.value) ? init_obj.value : [] );

    this.init();
}

/*
 * Initialize the widget: build it out with either the requested value,
 * or simply the default value
 */
flexField.prototype.init = function() {
    // Get rid of any existing content in the selector
    $(this.element).empty();

    // Create a dummy hidden input to hold the currently selected value
    $(this.element).before('<input type="hidden" name="'
        +$(this.element).attr('name')+'">');

    // Remove the name attribute from the existing <select>s, since we don't
    // want to create multiple form elements with the same name
    $(this.element).removeAttr('name');
    this.select_obj.removeAttr('name');

    // Populate the existing element with root-node data (which will have
    // no parent node, hence 'undefined')
    this.build_select( this.element, undefined );
};

/*
 * Re-initialize the widget with a new set of values.  Keeps the old
 * callback if not otherwise specified.
 */
flexField.prototype.reinit = function( init_obj ) {
    // Add empty object to data to create the empty option
    this.add_empty_object( init_obj );

    // Set the new data
    this.field_data = init_obj.data;

    // Re-set the desired values, if there are any
    this.force_values = ( $.isArray(init_obj.value) ? init_obj.value : [] );

    // Don't override the callback unless we've been given a new one
    if( init_obj.callback != undefined ) {
        this.set_callback( init_obj.callback );
    }

    // Get rid of old content in the selector, and re-build it with
    // the new root-node data
    $(this.element).empty();
    this.build_select( this.element, undefined );
};

/* Add an object with empty id and description for every flexfield child instances
 * Required to have an empty option for the flexfield selects
 */
flexField.prototype.add_empty_object = function( init_obj ) {
    _.chain(init_obj.data)
    .pluck('parent_id')
    .unique()
    .each(function(parent) {
        init_obj.data.unshift({id:'', description:'', parent_id: parent});
    }).value();
};

/*
 * Build the selector composed of elements which have parent_id as their
 * parent_id value. Build it into elem.
 * If the target_value is given, pre-select that value at this level.
 */
flexField.prototype.build_select = function( elem, parent_id ) {
    var target_value = this.force_values.shift();

    for( var i = 0; i < this.field_data.length; i++ ) {
        var item = this.field_data[i];
        if( item.parent_id == parent_id ) {
            var opt = $('<option value="'+item.id+'"></option>');
            opt.text(item.description);
            if( target_value != undefined && target_value == item.id ) {
                opt.attr('selected','selected');
            }
            $(elem).append(opt);
        }
    }

    // Copy 'this' before creating the on-change handler
    // (within which 'this' is the element that changed)
    var ff_obj = this;
    $(elem).change( function(event_obj){
        ff_obj.rebuild_children( this );
    });

    $(elem).change();
};

/*
 * Build out the children of a select element.  Call the callback once
 * we hit the terminal node.
 * Typically called on change of the select element, but can also be called
 * during initial creation.
 */
flexField.prototype.rebuild_children = function( elem ) {
    $(elem).nextAll('select').remove();
    var my_value = $(elem).val();

    // Find out if there are any children of this node
    var has_children = false;
    for( var i = 0; i < this.field_data.length; i++ ) {
        if( this.field_data[i].parent_id == my_value ) {
            has_children = true;
            break;
        }
    }

    if( has_children ) {
        var new_sel = this.select_obj.clone();
        $(elem).after(new_sel);
        this.build_select( new_sel, my_value );
    }
    else {
        // this is a terminal node.  Call the callback with the
        // selected element
        for( var i = 0; i < this.field_data.length; i++ ) {
            if( this.field_data[i].id == my_value ) {
                this.callback_func( this.field_data[i] );
                break;
            }
        }
    }
};

/*
 * Set the callback function that gets called when a value is selected.
 * Meant for internal use, but possibly useful outside as well.
 */
flexField.prototype.set_callback = function( callback ) {
    if( callback == undefined ) {
        this.callback_func = function(item){
            $(this.element).prev('input').val(item.id);
        };
    }
    else {
        this.callback_func = function(item){
            $(this.element).prev('input').val(item.id);
            callback(item);
        };
    }
};

/*
 * Select or return the requested leaf-node value.  Not very efficient! O(n^2)
 */
flexField.prototype.val = function( new_val ) {
    if( new_val == undefined ) {
        return $(this.element).prev('input').val();
    }

    var force_values = new Array();
    while( new_val != undefined ) {
        var found = false;
        for( var i = 0; i < this.field_data.length; i++ ) {
            if( this.field_data[i].id == new_val ) {
                found = true;
                force_values.unshift( new_val );
                new_val = this.field_data[i].parent_id;
            }
        }
        if( !found) break;
    }
    if( force_values.length ) {
        var root_val = force_values.shift();
        $(this.element).val(root_val);

        this.force_values = force_values;
        this.rebuild_children( this.element );
    }
}


/*
 * Set up the plugin to be callable
 */
$.fn[pluginName] = function( init_obj ) {
    // If there's no init_obj, check if we're trying to get the flexField
    // object for a previously-initialized select
    if( init_obj == undefined ) {
        return this.first().data('plugin_'+pluginName);
    }

    // Otherwise, initialize as normal
    return this.each(function() {
        if( ! $(this).is('select') ) {
            if( console && $.isFunction(console.log) )
                console.log('Attempted to initialize flexField on a non-select element');
            return true; // skip to next element in each()
        }

        // Allow safe reinitializing of existing select widgets
        if ($.data(this, 'plugin_' + pluginName)) {
            $.data(this, 'plugin_'+pluginName).reinit( init_obj );
        }
        else {
            $.data(this, 'plugin_' + pluginName,
                new flexField( this, init_obj ));
        }
    });
};

}(jQuery, window, document));



/*****************
 ** WEBPACK FOOTER
 ** ./js/vendor/jquery.flexField.js
 ** module id = 1207
 ** module chunks = 10
 **/